export const siteSettings = {
  name: "Keys Legacy",
  link: "https://keyslegacy.net",
  email: "support@keyslegacy.net",
  appLink: "https://app.keyslegacy.net",
};
